// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pHCosPNM49EhAanrfU3j{text-align:center;vertical-align:middle;min-width:40px;height:40px;padding:0;position:-webkit-sticky;position:sticky;right:0}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stickyRightContent": `pHCosPNM49EhAanrfU3j`
};
export default ___CSS_LOADER_EXPORT___;
